<template>
  <div>
    <template v-if="configData.Title">
      <div v-if="configData?.TitleStyle?.toLowerCase() === 'boxed'">
        <BoxedText text-class="heading-xl">{{ configData.Title }}</BoxedText>
      </div>
      <div v-else>
        <h2 class="heading-xs">{{ configData.Title }}</h2>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  configData: {
    Title?: string;
    TitleStyle?: string;
    FullBackground?: boolean;
  };
}

defineProps<Props>();
</script>

<style scoped></style>
